var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIceGrip = function SvgIceGrip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5,
    d: "M3.262 20.488 12 3.77l8.738 16.718zm4.115-2.4 2.967-5.796 1.215 1.463 1.432-2.558.825 1.523 2.89 5.369h-9.33z",
    vectorEffect: "non-scaling-stroke"
  })));
};
export { SvgIceGrip as ReactComponent };
export default __webpack_public_path__ + "4d78cd1e5bd90f3fd7c52d6e53ae750c.svg";